import { render, staticRenderFns } from "./AdditionalSettingsPart.vue?vue&type=template&id=0d95a419"
import script from "./AdditionalSettingsPart.vue?vue&type=script&lang=js"
export * from "./AdditionalSettingsPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports